// extracted by css-extract-rspack-plugin
export default {"organizationsTable":"__1YubDsDRENKoux","shareButton":"zj2bBeS1690rZTUK","organizationName":"wPm95Q9L8Ngd7vxm","sectionTitle":"tRemjjeul1ckdqLg"};